module.exports = __webpack_public_path__ + "img/neurology.d0eafc75.svg";